<template>
  <!-- 头部导航页面 -->
  <div class="header-container">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        v-for="(item, index) in newRoutes"
        :key="index"
        :index="index"
        @click="handleClick2(item, index)"
      >
        {{ item.name }}
      </el-menu-item>

      <el-aside class="aside-container" width="230px">
        <MenuTree :menuList="leftMenu"></MenuTree>
      </el-aside>
    </el-menu>
    <!-- 右上角用户 -->
    <div style="display: flex; align-items: center; justify-content: center">
      <span style="color: #fff; margin-right: 20px">
        {{ UserInfo.username }}
      </span>
      <span>
        <el-dropdown>
          <span class="icon-item">
            <img src="@/assets/user.png" width="18px" />
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>账号：{{ UserInfo.username }}</el-dropdown-item>
              <el-dropdown-item @click="handleEdit">修改密码</el-dropdown-item>
              <el-dropdown-item @click="handleExit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </span>
    </div>
    <changePassword ref="changePasswordRef"></changePassword>
  </div>
</template>

<script>
import changePassword from "@/components/changePassword";
import { useStore } from "vuex";
import { ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import MenuItem from "./menu";
import MenuTree from "./MenuTree";
import { ElMessageBox } from "element-plus";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    let activeIndex = ref(0);
    let newRoutes = computed(() => store.state.menus);
    let leftMenu = [];
    /**
     * 退出登录
     */
    const handleExit = () => {
      // 二次确认
      ElMessageBox.confirm("确定退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 退出登录
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.clear();
        router.push("/login");
      });
    };
    const changePasswordRef = ref(null);
    // 修改密码
    const handleEdit = () => {
      changePasswordRef.value.openChangePassword();
    };

    // 获取用户信息
    let UserInfo = localStorage.getItem("user");
    UserInfo = JSON.parse(UserInfo);

    const breadcrumbsData = computed(() => store.state.leftMenu);
    // 点击二级菜单展示左侧菜单
    const handleClick2 = (item, index, bool = true) => {
      localStorage.setItem("activeIndex", index);
      console.log(item, "setLeftMenusetLeftMenusetLeftMenusetLeftMenu");

      leftMenu = item.children;
      console.log(leftMenu);
      // 清空 leftMenu
      store.commit("clearLeftMenu");
      // 提交 leftMenu
      store.commit("setLeftMenu", item.children);
      store.commit("setBreadList", item);
      if (!bool) {
        console.log("?");
        activeIndex.value = String(index);
        return;
      }
      /* let puth = item.children[0].children ? item.children[0].children[0].path : item.children[0].path
            router.push(puth); */
      let path = "";
      if (item.menuType != 1) {
        let arr = [];

        const DG = (children = []) => {
          children.forEach((item2) => {
            if (item2.menuType == 1 && item2.path) {
              arr.push(item2.path);
            }
            if (item2.children) {
              DG(item2.children);
            }
          });
        };
        DG(item.children);
        console.log(arr);
        if (arr.length > 0) {
          path = arr[0];
        }
      } else {
        path = item.path;
      }
      if (path) {
        router.push(path);
      }
    };
    onMounted(() => {
      // 查询当前连接属于哪个一级菜单下的
      let { rootKey } = store.state.router2menu[route.meta.menuKey];
      let index = newRoutes.value.findIndex((item) => item.menuKey == rootKey);
      console.log(newRoutes.value, "indexindexindexindexindexindex");

      handleClick2(newRoutes.value[index], index, false);
    });
    return {
      changePasswordRef,
      UserInfo,
      handleExit,
      handleEdit,
      newRoutes,
      handleClick2,
      activeIndex,
      leftMenu,
      breadcrumbsData,
    };
  },
  components: {
    MenuItem,
    MenuTree,
    changePassword,
  },
};
</script>

<style lang="scss" scoped>
.el-icon--right {
  margin-left: 0;
  width: 40px;
  height: 40px;
}

.header-container {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 50px 0 0;
  // background: #fff;

  .top {
    display: flex;
  }

  >span {
    display: flex;
    align-items: center;
  }

  .icon-item {
    width: 32px;
    height: 32px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    border: 1px solid #ccc;
    box-sizing: border-box;
    cursor: pointer;
  }
}

:deep(.el-tooltip__trigger:focus-visible) {
  outline: unset;
}

// 顶部菜单
.el-menu-demo {
  width: 100%;
  // background-color: #fff;
  --el-menu-bg-color: :#333;

  // :deep(.is-active) {
  //   border-bottom: 2px solid rgb(96 139 223) !important;
  // }

  // :deep(.el-menu-item:hover) {
  //   background-color: rgb(98, 122, 154) !important;
  //   border-bottom: 2px solid rgb(96 139 223) !important;
  // }

  // :deep(.el-menu-item:focus) {
  //   background-color: rgb(98, 122, 154) !important;
  //   border-bottom: 2px solid rgb(96 139 223) !important;
  // }
}

.el-menu--horizontal.el-menu {
  border-bottom: none;
}
.el-menu--horizontal>.el-menu-item{
  font-size: 16px;
}
</style>